import { render } from "./IslamicCat.vue?vue&type=template&id=5b3d1b61"
import script from "./IslamicCat.vue?vue&type=script&lang=js"
export * from "./IslamicCat.vue?vue&type=script&lang=js"

import "./IslamicCat.vue?vue&type=style&index=0&id=5b3d1b61&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__